import React, { useState } from "react";

import Paper from "@material-ui/core/Paper";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

import { Roles } from "../config";

import PickerLoginForm from "./PickerLoginForm";
import CourierLoginForm from "./CourierLoginForm";
import GetirMHLoginForm from "./GetirMHLoginForm";

import logo from "../logo.svg";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.primary,
  },
  logo: {
    display: "block",
    width: 150,
    height: 150,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    marginLeft: "auto",
    marginRight: "auto",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  apiError: {
    color: "#ff1744",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Login() {
  const classes = useStyles();

  const [role, setRole] = useState(localStorage.getItem("role"));

  localStorage.setItem("role", role);

  const handleChangeRole = (e) => {
    const changedRole = e.target.value;
    localStorage.setItem("role", changedRole);
    setRole(changedRole);
  };

  const renderForm = () => {
    const forms = {
      courier: <CourierLoginForm />,
      picker: <PickerLoginForm />,
      getirMh: <GetirMHLoginForm />,
    };

    return forms[role] || forms[Roles.GETIR_MH];
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper className={classes.paper} component={Card}>
        <CardContent>
          <img src={logo} alt="Logo" className={classes.logo} />
          <Typography component="h1" variant="h6">
            Giriş Yap
          </Typography>
          <FormControl style={{ width: "100%" }}>
            <FormHelperText>Rol</FormHelperText>
            <Select
              native
              defaultValue={role}
              variant={"outlined"}
              fullWidth
              onChange={handleChangeRole}
              inputProps={{
                name: "select",
                id: "rol-select",
              }}
            >
              <option value={Roles.GETIR_MH}>Getir Müşteri Hizmetleri</option>
              <option value={Roles.PICKER}>Depo Görevlisi</option>
              <option value={Roles.COURIER}>Kurye</option>
            </Select>
          </FormControl>
          {renderForm()}
        </CardContent>
      </Paper>
    </Container>
  );
}
